import * as Icons from "@nova/component-icons"
import { EventKind } from "@nova/schemas"
import { Notification } from "../Notification"
import { AvatarIcon } from "../NotificationIcons"
import { NotificationKindProps } from "./types"

type LocationSharingKind = EventKind.LocationSharingStarted | EventKind.LocationSharingEnded

export const LocationSharingNotification = ({
    notification,
    copy,
    actorName,
}: NotificationKindProps<LocationSharingKind>) => (
    <Notification notification={notification}>
        <Notification.Icon>
            <AvatarIcon userId={notification.createdBy} fullName={actorName} />
        </Notification.Icon>
        <Notification.Content>
            <Notification.Heading>
                <Notification.Title>{copy.title}</Notification.Title>
                {copy.subtitle && <Notification.Subtitle>{copy.subtitle}</Notification.Subtitle>}
            </Notification.Heading>
            {notification.projectId && (
                <Notification.Action
                    label="Go to project"
                    RightIcon={Icons.ArrowRight}
                    to={{ projectId: notification.projectId }}
                />
            )}
        </Notification.Content>
    </Notification>
)
